
import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model } from '../../controlador';
import item from './estadisticas-situacion-empresa-lista-item.vue';
import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
import { Ventas } from '@/__env/lib/Pantalla/Ventas';
@Component( {
  name: "Componente",
  props: {},
  components: {
    item
  }
} )
export default class Componente extends Vue {
  public get Controlador () { return Model; }

  public MenuAbierto: boolean = false;
  public Buscador: string = '';
  public Estado: string = '';
  public SubModo: string = '';
  public Modo: string = '';

  protected Eventos: Function[] = [];
  beforeDestroy () {
    this.Eventos.forEach( x => x() );
  }

  async mounted () {
    this.Buscador = this.Controlador.Vista.Buscador;
    this.Estado = this.Controlador.Vista.Estado;
    this.Modo = this.Controlador.Vista.Modo;
    this.Eventos.push( this.Controlador.Vista.onBuscador.subscribe( () => this.Buscador = this.Controlador.Vista.Buscador ) );
    this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );
    this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () => this.Modo = this.Controlador.Vista.Modo ) );
    this.Eventos.push( this.Controlador.Vista.onSubModo.subscribe( () => this.SubModo = this.Controlador.Vista.SubModo ) );
    this.Eventos.push( this.Controlador.Vista.onMenuAbierto.subscribe( () => this.MenuAbierto = this.Controlador.Vista.MenuAbierto ) );

  }

  @Prop( { type: Empresa } )
  public Empresa: Empresa;
  @Watch( 'Empresa', { immediate: true } )
  onEmpresa () {
    this.buscar();
  }

  public Items: Ventas[] = [];

  async buscar () {
    let e = await Ventas.find( {
      empresa: this.Empresa.Id,
      limite: this.Limite
    } );
    this.Items = e.Items;
  }

  Limite: number = 5;
  async verMas () {
    this.Limite += 5;
    await this.buscar();
  }

}
